require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./winpe-collegium-sep-2021.json") })
        }
      }, "path---winpe-collegium-sep-2021");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---winpe-collegium-sep-2021!./.cache/json/winpe-collegium-sep-2021.json
// module id = 1269
// module chunks = 231608221292675